/* this file is transformed by vux-loader */
/* eslint-disable */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import XImg from './XImg';
export default {
  name: 'ListItem',
  components: {
    XImg: XImg
  },
  props: {
    imgSrc: String,
    imgWidth: {
      type: String,
      "default": '2.56rem'
    },
    imgHeight: {
      type: String,
      "default": '1.68rem'
    },
    margin: String,
    direction: {
      type: String,
      "default": 'row'
    },
    border: {
      type: Boolean,
      "default": false
    },
    imgDirection: {
      type: String,
      "default": 'left'
    },
    defaultImgSrc: String,
    invalidStr: String,
    invalid: {
      type: Boolean,
      "default": false
    },
    title: String,
    desc: String,
    mtop: String
  },
  data: function data() {
    var marginStyle = this.direction === 'row' ? {
      'margin-right': this.margin
    } : {
      'margin-bottom': this.margin
    };
    var styleObject = Object.assign({}, marginStyle);
    return {
      styleObject: styleObject
    };
  },
  created: function created() {},
  computed: {
    marginTop: function marginTop() {
      if (this.mtop) {
        return {
          'margin-top': this.mtop
        };
      } else {
        return {
          'margin-top': '.4rem'
        };
      }
    }
  }
};